import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import OnBoardingSectionBroker from "../../components/Home/OnBoardingSectionBroker";
import Loader from "../../components/Loader/Loader";
import Page from "../../finwell/pages/Page";
import { getModuleListingClearBroker, getModuleListingClear } from "../../redux/courses/actions";

const MyOnboardingPage = () => {

    const dispatch = useDispatch()
    const learningPathBroker = useSelector(state => state.courses.learningPathBroker);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        dispatch(getModuleListingClearBroker())
        dispatch(getModuleListingClear())
    }, [dispatch])

    useEffect(() => {
        // console.log('Action Path broker', learningPathBroker)
        if (!_.isEmpty(learningPathBroker)) {
            setIsLoading(false);
        }
    }, [learningPathBroker])

    return (
        <>
            <Loader start={isLoading} />
            <Page>
                <div
                    className="New-dashboard learning"
                >
                    <section className="my_onbording pt-5g pb-4">
                    <div className="container">
                        <div className="search_heading mb-5">
                            <p className="lable-heading_search">My Onboarding</p>
                        </div>
                        {/* <OnBoardingSectionBroker /> */}
                        <OnBoardingSectionBroker
                            fetchData={true} 
                            hideLine={true}
                        />
                    </div>
                    </section>
                </div>
            </Page>
        </>
    );
}

export default MyOnboardingPage;